import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import SrvButton from "../../../../components/global/SrvButton";
import { useSelector } from "react-redux";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../../util/ErrorAdd";

function ModalComplete({ show, onHide, onHideCard, model }) {

    const stateList = useSelector((state) => state.taskRTrackerList);//Редюсер задач

    //ОТКРЫТИЕ/ЗАКРЫТИЕ МОДАЛЬНОЕ ОКНО
    useEffect(() => {
        //открытие
        if (show === true) {
            setLoading(false);
            setLog(null);
        }
    }, [show]);

    const [loading, setLoading] = useState(false);
    const [log, setLog] = useState(null);

    const [formComment, setFormComment] = useState(null);
    const [formComfirmAll, setFormComfirmAll] = useState(false);

    function completeHandler() {
        setLoading(true);

        if (formComfirmAll === false) {
            axios.post('/api_tracker/taskR/trackerComplete', { ID_TaskR_Tracker: model.ID, ID_User: model.ID_User, Comment: formComment })
                .then((res) => {
                    if (res.data.Status === 1) {
                        onHide();
                        onHideCard();
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        else {
            const id_tab = model.id_tab;
            const id_user = model.ID_User;
            const taskItems = stateList.list.filter(a => a.ID_TaskR === model.ID_TaskR & a.id_tab === id_tab & a.ID_User === id_user).map((item) => { return item.ID });

            axios.post('/api_tracker/taskR/trackerCompleteMass', { Items: taskItems, ID_User: model.ID_User, Comment: formComment })
                .then((res) => {
                    if (res.data.Status === 1) {
                        onHide();
                        onHideCard();
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        model !== null && (
            <>
                <Modal show={show} onHide={onHide} size="md">
                    <Modal.Body>
                        <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                        <div className="modal_title text-center">Завершение задачи</div>
                        <div className="mt-15">
                            Подтвердите завершение задачи <b>«{model.Name}»</b>
                        </div>
                        <Form.Group className="mt-15" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Комментарий</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Не обязательно" onChange={(e) => setFormComment(e.target.value)} />
                        </Form.Group>
                        <Form.Check className="mt-15" onChange={(e) => setFormComfirmAll(e.target.checked)}
                            id="comfirm_all_task"
                            label={'Выполнить все задачи «' + model.Name + '»'}
                        />

                        {log != null && (
                            <div className="form_error text-center">
                                {log}
                            </div>
                        )}

                        <div className="row mt-15">
                            <div className="col-md-12 text-center">
                                <SrvButton typeBtn="finish" size='lg' onClick={() => completeHandler()} loading={loading} />
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        )
    );
}
export default ModalComplete;
